// import Cookies from "js-cookie";

export const HEADERS = {
  DOI_HEADER: {
    Accept: "application/json; charset=UTF-8",
  },
  DEFAULT_HEADER: {
    "Content-Type": "application/json; charset=UTF-8",
  },
  // QUAN TRỌNG: dùng getter để ĐỌC token tại THỜI ĐIỂM GỌI API, không phải lúc
  // import module. Trước đây là object tĩnh nên token bị "đóng băng" lúc tải
  // trang -> sau khi đăng nhập lại bằng refresh token (không reload) thì các
  // request vẫn gửi token cũ/null -> lỗi 401 (vd: getSeasonList ở màn quản lý
  // năm tổ chức). Các API định nghĩa dạng hàm (() => ({ headers: ... })) nên
  // getter chạy lại mỗi lần gọi API và luôn lấy token mới nhất.
  get TOKEN_HEADER() {
    return {
      "Content-Type": "application/json; charset=UTF-8",
      "User-Info": localStorage.getItem("userInfo") || "",
      Authorization: localStorage.getItem("access_token"),
    };
  },
  get UPLOAD_FILE_HEADER() {
    return {
      "Content-Type": "Content-Type: multipart/form-data;", // ?
      Authorization: localStorage.getItem("access_token"),
    };
  },
};
